import './App.css';
import MenuBar from './components/MenuBar';
import TitleCard from './components/TitleCard';
import ProductCard from './components/ProductCard';
import SubscriptionCard from './components/SubscriptionCard';
import DateTimeCard from './components/DateTimeCard';
import FooterBar from './components/FooterBar';
import SpacerBar from './components/SpacerBar'
import LandingPopup from './components/LandingPopup';

import { useState} from "react";




function App() {

  const styleStrings = {
  "flat": {
    "d0": "Flat design embraces minimalism with crisp edges, bright colors, and open space.",
    "d1": "Gradients and shadows are omitted to keep interfaces simple and clean.",
    "d2": "Mobile apps and services typically use flat design due to the limited space in screen size."
  },
  "neumorphism": {
    "d0": "Neumorphism uses soft shadows and highlights to create a 3D effect with the background.",
    "d1": "It evolved from the skeuomorphic design style, which uses gradients and shadows to emulate real world elements.",
    "d2": "It's criticized due to low contrast accessibility problems, and is more reliable in smaller elements or used with higher contrast elements."
  },
  "neobrutalism": {
    "d0": "Neo-brutalism emphasizes raw, chunky layouts with sharp contrast and minimal styling.",
    "d1": "It often uses stark colors, exposed borders, and monospaced typefaces to make a statement.",
    "d2": "It's a rejection of polish in favor of authenticity."
  },
  "glassmorphism": {
    "d0": "Glassmorphism features blurred backgrounds, transparency, and subtle highlights to mimic frosted glass.",
    "d1": "It adds a sophisticated and organic look while keeping the interface light and clean.",
    "d2": "Using glassmorphism in a pinned element (like a menubar), or an element that moves over a complex background emphasizes the look."
  }
};

  const [style, setStyle] = useState("flat")
  return (
    <div className="App">
      <LandingPopup/>
      <MenuBar style={style} setStyle={setStyle}></MenuBar>
      <TitleCard style={style}></TitleCard>
      <SpacerBar style={style} text={styleStrings[style]["d0"]}></SpacerBar>
      <ProductCard style={style}></ProductCard>
      <SpacerBar style={style} text={styleStrings[style]["d1"]}></SpacerBar>
      <SubscriptionCard style={style}></SubscriptionCard>
      <SpacerBar style={style} text={styleStrings[style]["d2"]}></SpacerBar>
      <DateTimeCard style={style}></DateTimeCard>
      <FooterBar style={style}></FooterBar>
    </div>
  );
}

export default App;
